import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { bootstrapQueryOptions } from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import { canManageOrganizationAsOwner } from '@/features/organizations/domain/organization-role'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { OrganizationAgentNewPage } from '@/pages/organization/agents/new'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'
import { redirectToGtmEntry } from '@/shared/lib/gtm-route-guard'

const searchSchema = z.object({
  template: z.string().uuid().optional(),
})

export const Route = createFileRoute('/$lang/organization/agents/new')({
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: async ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      redirectToGtmEntry(context, params)
    }
    requireAuthenticated(context, params)
    const bootstrap = await context.queryClient.ensureQueryData(
      bootstrapQueryOptions(),
    )
    if (!canManageOrganizationAsOwner(bootstrap.organization?.role)) {
      throw redirect({
        to: '/$lang/organization/agents',
        params: { lang: params.lang },
      })
    }
  },
  component: OrganizationAgentNewPage,
  staticData: { layout: 'main' },
})
